module.exports = __webpack_public_path__ + "static/media/logo.f15d2a16.png";